import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TChannel } from '../../../_shared/types/channel.type';
// import { TChannel } from '@/features/channel-integration/_shared/types/channel.type';

/**
 * Add Page Meta Input Schema
 */
export const addPageMetaValidationSchema = z.object({
  state: z.string({ required_error: 'State is required' }),
  ids: z.array(z.string({ required_error: 'Page ids are required' })),
});
export type TAddPageMetaValidation = z.infer<typeof addPageMetaValidationSchema>;
export type TAddPageMetaPayload = TAddPageMetaValidation;
export type TAddPageMetaResponse = ApiResponse<TChannel>;

export const addPageMeta = async (payload: TAddPageMetaPayload): Promise<TAddPageMetaResponse> => {
  const url = `/integration/meta/page-ids`;

  const payloadData = {
    state: payload.state,
    ids: payload.ids,
  };

  return axiosInstance.post(url, payloadData);
};

/**
 * Use Add Page Meta React-Query Hook
 */
type UseAddPageMetaMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof addPageMeta, AxiosErrorCustom>;
};

export const useAddPageMetaMutation = ({ mutationConfig }: UseAddPageMetaMutationOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: addPageMeta,
    ...restConfig,
  });
};
